<template>
<!--  <div class="overviewTypeOpPage" ref="ui">-->
  <div>

      <div v-if="this.$store.state.OverviewDisplayMode === 1 ">
        <el-radio v-model="overviewType" v-show="$store.state.showOverview" @change="overviewChanges" label="传统概貌图" style="margin: 0 16px 16px 0">{{translateText('textMap.','传统概貌图')}}</el-radio>
        <el-radio v-model="overviewType" v-show="$store.state.showEquipment" @change="overviewChanges" label="设备概貌图" style="margin: 0 16px 16px 0">{{translateText('textMap.','设备概貌图')}}</el-radio>
        <el-radio v-model="overviewType" v-show="$store.state.showProcess" @change="overviewChanges" label="工艺流程图" style="margin: 0 16px 16px 0">{{translateText('textMap.','工艺流程图')}}</el-radio>
      </div>
      <div v-if="this.$store.state.OverviewDisplayMode === 2 ">
        <el-radio v-model="overviewType" @change="overviewChanges" label="设备概貌图" style="margin: 0 16px 16px 0">{{translateText('textMap.','设备概貌图')}}</el-radio>
        <el-radio v-show="showProcessOverview == 1" v-model="overviewType" @change="overviewChanges" label="工艺流程图" style="margin: 0 16px 16px 0">{{translateText('textMap.','工艺流程图')}}</el-radio>
      </div>

  </div>

</template>
<script>
export default{
  // 右侧上方的公共组件
  name: 'overviewTypeOpPage',
  props: ['inputChecked'],
  data() {
    return{
      overviewType: '',
    }
  },
  methods: {
    overviewChanges() {
      console.log("happen->概貌图切换", this.overviewType)
      this.$emit("overviewChange", this.overviewType)
      this.inputChecked = false
    },
  },
  computed:{
    overviewDisplayMode(){
      return this.$store.state.OverviewDisplayMode
    },
    showProcessOverview(){
      return this.$store.state.showProcessOverview
    }
  },
  created() {
    if(this.$store.state.OverviewDisplayMode == 1){
      if(this.$store.state.showOverview){
        this.overviewType = "传统概貌图"
      }else if(this.$store.state.showEquipment){
        this.overviewType = "设备概貌图"
      }else if(this.$store.state.showProcess){
        this.overviewType = "工艺流程图"
      }
    }else{
      this.overviewType = '设备概貌图'
    }
  },
  // mounted() {
  //   this.mycolor = this.$store.state.textcolor;
  //   this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
  //   this.$refs.ui.style.setProperty('--textcolcor', this.$store.state.textcolor);
  //   this.$refs.ui.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
  //   this.$refs.ui.style.setProperty('--treeinputbgcolor', this.$store.state.treeinputbgcolor);
  //   this.$refs.ui.style.setProperty('--labelcolor', this.$store.state.labelcolor);
  //
  // },
  // computed:{
  //   topiccolor(val) {
  //     return this.$store.state.topiccolor;
  //   }
  // },
  watch:{
    overviewDisplayMode(val){
      if(val == 1){
        if(this.$store.state.showOverview){
          this.overviewType = "传统概貌图"
        }else if(this.$store.state.showEquipment){
          this.overviewType = "设备概貌图"
        }else if(this.$store.state.showProcess){
          this.overviewType = "工艺流程图"
        }
      }else{
        this.overviewType = '设备概貌图'
      }
    },
    // topiccolor(val) {
    //
    //   // console.log('我的颜色',this.$store.state.textcolor)
    //   this.mycolor = this.$store.state.textcolor;
    //   console.log('我的颜色zi',this.mycolor)
    //   this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
    //   this.$refs.ui.style.setProperty('--textcolcor', this.$store.state.textcolor);
    //   this.$refs.ui.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
    //   this.$refs.ui.style.setProperty('--treeinputbgcolor', this.$store.state.treeinputbgcolor);
    //   this.$refs.ui.style.setProperty('--labelcolor', this.$store.state.labelcolor);
    //
    // }
  }
}
</script>

<style lang="scss">
//.overviewTypeOpPage {
//  --leftconbgcolor: #303749;
//  --textcolor: #ffffff;
//  --activetextcolor: #359186;
//  --treeinputbgcolor: #ffffff;
//  --labelcolor: #696B6F;
//  .overviewTypes {
//    padding: 2px;
//    margin-left: 20px;
//    margin-right: 10px;
//    background-color: var(--leftconbgcolor);
//    .el-radio__label {
//      font-size: 14px;
//      color: var(--textcolor);
//    }
//  }
//  .el-header {
//    //height: 13px;
//    background: var(--leftconbgcolor);
//
//    .options {
//      color: var(--activetextcolor);
//    }
//  }
//  .checked{
//    padding: 2px;
//    margin-left: 20px;
//    margin-right: 10px;
//    background-color: var(--leftconbgcolor);
//  }
//  .overviewType {
//    padding: 2px;
//    margin-left: 20px;
//    margin-right: 10px;
//    background-color: var(--leftconbgcolor);
//    .el-radio__label {
//      font-size: 14px;
//      color: var(--textcolcor);
//    }
//  }
//}
</style>



// WEBPACK FOOTER //
// src/components/ComUtils/OverviewTypeOpPage.vue